import useSWR, { SWRResponse } from 'swr';
import { useProduct, useCart } from '@chordcommerce/react-autonomy';

const useVariantAvailability = ({
  sku,
  shouldFetch,
}: {
  sku: string;
  shouldFetch: boolean;
}): SWRResponse<boolean, any, any> => {
  const { getStockAvailability } = useProduct();
  const { cart } = useCart();

  const fetcher = async (sku: string, channel?: string) => {
    const stock = await getStockAvailability({ sku, channel });
    return stock.inStock ? stock.inStock : stock.isBackorderable;
  };

  return useSWR(shouldFetch ? [sku, cart.channel] : null, () => fetcher(sku ?? '', cart.channel));
};

export default useVariantAvailability;
